import { render, staticRenderFns } from "./PublicationDemands.vue?vue&type=template&id=08771fae&"
import script from "./PublicationDemands.vue?vue&type=script&lang=js&"
export * from "./PublicationDemands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports